<template>
    <img src="@/assets/imgs/404.jpg" alt="" class="w-100 h-100">
</template>

<script>
export default{
    
}
</script>
